"use client";

import Image from "next/image";
import Link from "next/link";
import { CareerHeroContent } from "@/lib/content";

const CareerHero = () => {
  return (
    <section className="w-full pt-24 md:pt-32 pb-12 bg-white" aria-labelledby="hero-heading">
      <div className="max-w-7xl mx-auto px-6 text-center">

        {/* Rating badge - Semantic Social Proof */}
        <div 
          className="flex justify-center mb-8 animate-in fade-in slide-in-from-top-4 duration-700"
          role="note" 
          aria-label="Company culture rating: 4.4 out of 5 stars"
        >
          <div className="flex items-center gap-3 border border-gray-200 rounded-full px-5 py-1.5 text-sm bg-gray-50/50 shadow-sm">
            <span className="text-green-600 font-bold" aria-hidden="true">4.4 ★</span>
            <span className="text-gray-700 font-medium">&apos;{CareerHeroContent.subText}&apos;</span>
          </div>
        </div>

        {/* Heading - SEO Primary */}
        <h1 
          id="hero-heading"
          className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-[1.1] tracking-tight"
        >
          <span className="text-[#4F7AC2]">{CareerHeroContent.highlightTitle}</span> {CareerHeroContent.title}
        </h1>

        {/* Subtitle - Readable Line Height */}
        <p className="mt-8 text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed font-medium">
          {CareerHeroContent.description}
        </p>

        {/* CTA - Accessible Button */}
        <div className="mt-10">
          <Link
            href={CareerHeroContent.buttonUrl}
            className="inline-flex items-center gap-2 bg-[#4F7AC2] hover:bg-gray-900 text-white px-10 py-4 rounded-xl text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-[#4F7AC2]/20 focus:ring-4 focus:ring-[#4F7AC2]/30 outline-none"
          >
           {CareerHeroContent.button}
            <span aria-hidden="true" className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
        </div>

        {/* Image Section - Performance Optimized */}
        <div className="mt-20 relative w-full h-[350px] md:h-[500px] lg:h-[600px] rounded-[2.5rem] overflow-hidden shadow-2xl bg-gray-100">
          <Image
            src={CareerHeroContent.imageUrl}
            alt="Seternity Solutions team working together in a modern office environment"
            fill
            className="object-cover transition-scale duration-1000 hover:scale-105"
            priority
            fetchPriority="high"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 90vw, 1280px"
          />
          {/* Subtle overlay to help image blend if it's very bright */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" />
        </div>

      </div>
    </section>
  );
};

export default CareerHero;